import type { ComponentProps, ReactNode } from 'react';
import { Card } from '../card';
import { ReadMore } from '../read-more';

type P = {
  card?: ComponentProps<typeof Card>;
  children: ReactNode;
  readMore?: Omit<ComponentProps<typeof ReadMore>, 'children'>;
};

// TODO collapsible height 200px should be for whole card, now it works for its content
const CollapsibleCard = ({ card, children, readMore }: P) => (
  <Card {...card}>
    <ReadMore allowCollapse buttonPaddingBottom={false} collapse={{ height: 'small' }} {...readMore}>
      {children}
    </ReadMore>
  </Card>
);

export default CollapsibleCard;
